export const getProposalTemplates = () => dispatch =>
  dispatch({
    type: 'GET_PROPOSAL_TEMPLATES',
    payload: {
      request: {
        url: '/api/library/proposals'
      }
    }
  })

export const createProposalTemplate = template => dispatch =>
  dispatch({
    type: 'CREATE_PROPOSAL_TEMPLATE',
    payload: {
      request: {
        url: '/api/library/proposals',
        method: 'post',
        data: template
      }
    }
  })

export const updateProposalTemplate = template => dispatch =>
  dispatch({
    type: 'UPDATE_PROPOSAL_TEMPLATE',
    payload: {
      request: {
        url: `/api/library/proposals/${template._id}`,
        method: 'patch',
        data: template
      }
    }
  })

export const deleteProposalTemplate = templateId => dispatch =>
  dispatch({
    type: 'DELETE_PROPOSAL_TEMPLATE',
    payload: {
      request: {
        url: `/api/library/proposals/${templateId}`,
        method: 'delete'
      }
    }
  })

export const getProposalTemplate = templateId => dispatch =>
  dispatch({
    type: 'GET_PROPOSAL_TEMPLATE',
    payload: {
      request: {
        url: `/api/library/proposals/${templateId}`
      }
    }
  })
